export default __webpack_public_path__ + "static/media/symbol-defs.431ca4f2.svg";